import React from 'react';
import { FiAward, FiLock, FiCheckCircle } from 'react-icons/fi';
import { useAppContext } from '../context/AppContext';

export const Certifications = () => {
  const { certs } = useAppContext();

  return (
    <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-white mb-2">My Certifications</h1>
        <p className="text-slate-400">Track your progress toward industry-recognized credentials.</p>
      </div>

      <div className="space-y-4">
        {certs.map((cert) => (
          <div key={cert.id} className={`glass-panel p-6 rounded-2xl relative overflow-hidden ${cert.locked ? 'opacity-75' : ''}`}>
            {cert.locked && (
              <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm z-10 flex flex-col items-center justify-center">
                <FiLock className="text-3xl text-slate-400 mb-2" />
                <p className="text-sm font-medium text-slate-300">Complete Previous Tier to Unlock</p>
              </div>
            )}
            
            <div className="flex items-start gap-4">
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center shrink-0 ${cert.progress === 100 ? 'bg-amber-500/20 text-amber-500' : 'bg-blue-500/20 text-blue-400'}`}>
                <FiAward className="text-3xl" />
              </div>
              
              <div className="flex-1">
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-lg font-bold text-white">{cert.title}</h3>
                  <span className="text-sm font-medium text-slate-400">{cert.progress}%</span>
                </div>
                
                <div className="w-full bg-slate-800 rounded-full h-2.5 mb-3 overflow-hidden border border-slate-700">
                  <div className="bg-gradient-to-r from-blue-500 to-cyan-400 h-2.5 rounded-full" style={{ width: `${cert.progress}%` }}></div>
                </div>
                
                <div className="flex justify-between items-center">
                  <p className="text-sm text-slate-400">{cert.completedModules} / {cert.totalModules} Modules</p>
                  {cert.progress >= 100 ? (
                    <span className="flex items-center gap-1 text-sm font-medium text-emerald-400"><FiCheckCircle /> Certified</span>
                  ) : (
                    <span className="text-sm font-medium text-blue-400 hover:text-blue-300 cursor-pointer">Continue Track &rarr;</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};